<template>
  
  <path 
    :style = "style"
    :d     = "points" 

    @contextmenu.prevent  = "$emit('contextmenu', $event)"
    @mousedown.prevent    = "$emit('mousedown', $event);"
  />

</template>

<script>

export default {

  // #region Properties

  props: {
    shape: Object
  },
  computed: {
    style() {
      return {
        'fill':          'transparent',
        'vector-effect': 'non-scaling-stroke',
        'stroke':        this.shape.color,
        'stroke-width':  '4'
      }
    },
    points() {
      // Build an SVG path:
      let points = this.shape.points.map(p => `L ${p.x} ${p.y}`).join(' ');
      points = 'M ' + points.substr(1);
      return points;
    }
  }

  // #endregion Properties

}

</script>